/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type admin_RunMigrationsRequest = {
    action: admin_RunMigrationsRequest.action;
    /**
     * ["event-go-service", "customer-go-service", "all"]
     */
    services: Array<string>;
    /**
     * For down/force migrations
     */
    steps?: number;
};
export namespace admin_RunMigrationsRequest {
    export enum action {
        UP = 'up',
        DOWN = 'down',
        FORCE = 'force',
        VERSION = 'version',
    }
}

